import React, { useState, useRef } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useFormik } from "formik";
import { useLocation } from "react-router-dom";
import Logo from "../../Assets/Images/Logo1.png";
import "./DeleteAccount.css";

const REASONS = [
  "I need to focus",
  "I didn’t find the app useful",
  "I didn’t get paired",
  "My peers didn’t respond",
  "Others (please specify)",
];

const DeleteAccount = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isWebView = searchParams.get("webview") === "true";
  const form = useRef();

  const validate = (values) => {
    const errors = {};

    if (!values.name || !values.name.trim()) {
      errors.name = "Name is required";
    } else if (values.name.length > 50) {
      errors.name = "Must be 50 characters or less";
    }

    if (!values.email || !values.email.trim()) {
      errors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }

    if (!values.number || !values.number.trim()) {
      errors.number = "Mobile number is required";
    } else if (!/^\d{10}$/.test(values.number.trim())) {
      errors.number = "Invalid Phone Number (10 digits required)";
    }

    if (
      values.reason === "Others (please specify)" &&
      !values.otherReason.trim()
    ) {
      errors.otherReason = "Please specify your reason";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      number: "",
      reason: "Others (please specify)",
      otherReason: "",
    },
    validate,
    onSubmit: async (values) => {
      setLoading(true);
      const finalReason =
        values.reason === "Others (please specify)"
          ? values.otherReason
          : values.reason;

      try {
        const response = await fetch(
          "https://api.thegenwe.com/api/webhook/sendEmail",
          {
            method: "POST",
            headers: {
              "x-encrypt": "true",
              "x-api-key":
                "fyLuYdxw//ASRDtnu5H9hC67S7SF8I5PWUAnYuRWzX1qBS7L1ETXf22xqfvNeBke7dzugCOGCN2e0YFo++Z7fXM1tWnfIGI2xcnv/2k1q3kYNfhKKIVMwvC2U9r8TBNhXsbf7yt5bxJZqzsknYyPlJl8Wr59sYg6dts8LvUUpqs=",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              subject: `Delete Account Request from ${values.name}`,
              emailBody: `
              Name: ${values.name}\n
              Number: ${values.number}\n
              Email: ${values.email}\n
              Reason: ${finalReason}
            `,
            }),
          }
        );

        if (response.ok) {
          alert("Your request submitted successfully!");
          formik.resetForm();
        } else {
          alert("Failed to submit request.");
        }
      } catch (error) {
        console.error(error);
        alert("Failed to submit request.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="delete-account-wrapper">
      <div>
        {!isWebView && (
          <div className="container">
            <Header />
          </div>
        )}

        <div className="delete-account-container">
          <div className="delete-account-header">
            {isWebView && (
              <img
                src={Logo}
                alt="GenWE Logo"
                className="delete-account-logo"
              />
            )}
            <h1 className="delete-account-title">Delete Account</h1>
            <div className="delete-account-intro">
              <p>Hi,</p>
              <p>
                We are sorry to see you go. Please fill this form. Your data will
                be deleted within 48 hours.
              </p>
              <p
                // href="mailto:friends@genwe.today"
                className="delete-account-support-link"
              >
                GenWE Support
              </p>
            </div>
          </div>

          <form
            ref={form}
            className="delete-account-form"
            onSubmit={formik.handleSubmit}
          >
            <div className="form-group">
              <label htmlFor="name" className="field-label">
                Name
              </label>
              <input
                type="text"
                className="delete-account-input"
                id="name"
                name="name"
                placeholder="Enter Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name ? (
                <div className="delete-account-error">{formik.errors.name}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="email" className="field-label">
                Email Id
              </label>
              <input
                type="email"
                className="delete-account-input"
                id="email"
                name="email"
                placeholder="Enter Email Id You Are Registered With"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="delete-account-error">{formik.errors.email}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="number" className="field-label">
                Mobile Number
              </label>
              <input
                type="tel"
                className="delete-account-input"
                id="number"
                name="number"
                placeholder="Enter Mobile Number You Are Registered With"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.number}
              />
              {formik.touched.number && formik.errors.number ? (
                <div className="delete-account-error">
                  {formik.errors.number}
                </div>
              ) : null}
            </div>

            <div className="delete-account-reasons-group">
              <div className="reasons-title">
                I want to delete my account because:
              </div>
              <div className="reasons-list">
                {REASONS.map((reason) => (
                  <label key={reason} className="reason-radio-label">
                    <input
                      type="radio"
                      name="reason"
                      value={reason}
                      checked={formik.values.reason === reason}
                      onChange={formik.handleChange}
                    />
                    <span>{reason}</span>
                  </label>
                ))}
              </div>

              {formik.values.reason === "Others (please specify)" && (
                <div className="reason-other-input-container">
                  <textarea
                    className="delete-account-textarea"
                    name="otherReason"
                    id="otherReason"
                    rows="4"
                    placeholder="Type here"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.otherReason}
                  />
                  {formik.touched.otherReason && formik.errors.otherReason ? (
                    <div className="delete-account-error">
                      {formik.errors.otherReason}
                    </div>
                  ) : null}
                </div>
              )}
            </div>

            <div>
              <button
                type="submit"
                className="delete-account-submit-btn"
                disabled={loading}
              >
                {loading ? "Loading..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {!isWebView && (
        <div className="FooterMargin">
          <Footer />
        </div>
      )}
    </div>
  );
};

export default DeleteAccount;
